import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconButton } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CalendarWeek } from 'src/app/shared/interfaces/holidays.interface';
import { HolidaysService } from 'src/app/shared/services/holidays/holidays.service';

@Component({
  selector: 'app-horizontal-calendar',
  imports: [
    MatIconModule,
    MatIconButton,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
  ],
  templateUrl: './horizontal-calendar.component.html',
  styleUrl: './horizontal-calendar.component.css',
})
export class HorizontalCalendarComponent implements OnChanges {
  @Input() weeks: CalendarWeek[] = [];
  @Input() isLoading: boolean = false;
  @Input() refreshingWeekNumber: number | null = null;
  @Output() refreshWeek = new EventEmitter<number>();
  @Output() weekUpdated = new EventEmitter<void>();

  editingWeekNumber: number | null = null;

  // Array representing N dynamic right columns
  rightColumns: Array<{
    id: number;
    danger?: boolean;
    week: string;
    weekNumber: number;
    dates: string;
    metrics: (number | string)[];
  }> = [];

  constructor(private holidaysService: HolidaysService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['weeks'] && this.weeks) {
      this.transformWeeksToColumns();
    }
  }

  private transformWeeksToColumns(): void {
    this.rightColumns = this.weeks.map((week) => ({
      id: week.id,
      danger: week.has_warnings,
      week: week.week_name.replace('Week', 'Semana'),
      weekNumber: week.week_number,
      dates: `${week.start_date} - ${week.end_date}`,
      metrics: [
        week.camiones_total,
        week.camiones_averiados,
        week.camiones_disponibles,
        week.conductores_total,
        week.conductores_vacaciones,
        week.conductores_indisponibles,
        week.conductores_prevision,
        week.conductores_disponibles,
        week.camiones_parados.actual,
        week.camiones_parados.objetivo,
        week.slots,
      ],
    }));
  }

  onRefreshClick(weekNumber: number): void {
    this.refreshWeek.emit(weekNumber);
  }

  editFields(weekNumber: number): void {
    // Toggle edit mode for this specific week
    if (this.editingWeekNumber === weekNumber) {
      // Save changes when closing edit mode
      this.saveWeekConfig(weekNumber);
    } else {
      // Start editing this week
      this.editingWeekNumber = weekNumber;
    }
  }

  saveWeekConfig(weekNumber: number): void {
    const column = this.rightColumns.find(
      (col) => col.weekNumber === weekNumber
    );
    if (!column) {
      console.error('Column not found for week number:', weekNumber);
      return;
    }

    // Get the edited values from the metrics array
    // Index 9 is camions_parats_objectiu, index 10 is slots
    const camions_parats_objectiu = Number(column.metrics[9]);
    const slots = Number(column.metrics[10]);

    const updateData = {
      camions_parats_objectiu,
      slots,
    };

    this.holidaysService.updateWeekConfig(column.id, updateData).subscribe({
      next: (response) => {
        console.log('Week config updated successfully:', response);
        this.editingWeekNumber = null;
        // Emit event to parent to refresh data
        this.weekUpdated.emit();
      },
      error: (error) => {
        console.error('Error updating week config:', error);
        // Optionally keep edit mode open on error
        // this.editingWeekNumber = weekNumber;
      },
    });
  }

  isEditingWeek(weekNumber: number): boolean {
    return this.editingWeekNumber === weekNumber;
  }

  isRefreshingWeek(weekNumber: number): boolean {
    return this.refreshingWeekNumber === weekNumber;
  }
}
